import NumberFormatter from "../../commons/NumberFormatter";

const { removeRedundantZeros, removeSpacesFromString } = NumberFormatter;

const convertToNumber = (string) => {
  return Number(NumberFormatter.removeSpacesFromString(string));
};

export const calculatePrice = (
  input,
  afaParam,
  mennyisegParam,
  tizedesjegy,
  removeRedundantZerosOnNettoEgysegAr
) => {
  let nettoE, afaE, bruttoE, nettoO, afaO, bruttoO;
  // Azok az ágak kiszűrése, ahol nem kell számolni (pl. "5." bemenet, ami az "5.1" beírása közben lép elő)
  if (input === undefined) {
    nettoE = "";
    afaE = "";
    bruttoE = "";
    nettoO = "";
    afaO = "";
    bruttoO = "";
  } else {
    let afaErtek = convertToNumber(afaParam);
    let mennyiseg = convertToNumber(mennyisegParam);
    let afa = 1 + afaErtek / 100;
    // A felesleges tizedesjegyek levágása miatt van szorozva a szám
    // Egység esetén kerekítés nélkül kell 6 számjegy, ezért le van vágva minden további számjegy, de az Össz. értéknél kell kerekítés
    let kerekitesSzorzoAltalanos = 10 ** 6;
    let kerekitesSzorzoTizedesjegy = 10 ** (tizedesjegy == null ? 6 : tizedesjegy);
    let inputNumber = convertToNumber(input);
    nettoE = Math.floor(inputNumber * kerekitesSzorzoAltalanos) / kerekitesSzorzoAltalanos;
    bruttoE = Math.round(nettoE * afa * kerekitesSzorzoAltalanos) / kerekitesSzorzoAltalanos;
    nettoO = Math.round(nettoE * mennyiseg * kerekitesSzorzoTizedesjegy) / kerekitesSzorzoTizedesjegy;
    bruttoO = Math.round(nettoE * afa * mennyiseg * kerekitesSzorzoTizedesjegy) / kerekitesSzorzoTizedesjegy;
    afaE = bruttoE - nettoE;
    afaO = bruttoO - nettoO;
  }

  return [
    removeSpacesFromString(removeRedundantZerosOnNettoEgysegAr ? removeRedundantZeros(input) : input),
    removeRedundantZeros(typeof afaE === 'number' ? afaE.toFixed(6) : afaE),
    removeRedundantZeros(bruttoE),
    removeRedundantZeros(nettoO),
    removeRedundantZeros(typeof afaO === 'number' ? afaO.toFixed(6) : afaO),
    removeRedundantZeros(bruttoO),
  ];
};
